import { Component } from 'react';
import PropTypes from 'prop-types';
import DOM from 'react-dom-factories';

function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default class DateTimePickerMonths extends Component {
  static propTypes = {
    viewDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    prevIcon: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    nextIcon: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    addTime: PropTypes.func,
    showView: PropTypes.func,
    subtractTime: PropTypes.func,
    updateSelectedDate: PropTypes.func,
    renderMonth: PropTypes.func,
    setDate: PropTypes.func,
    updateOn: PropTypes.string,
    selectedDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    isValidDate: PropTypes.bool,
    fullMonth: PropTypes.bool,
  };

  constructor (props) {
    super(props);

    this.renderMonth = this.renderMonth.bind(this);
    this.renderMonths = this.renderMonths.bind(this);
    this.alwaysValidDate = this.alwaysValidDate.bind(this);
    this.updateSelectedMonth = this.updateSelectedMonth.bind(this);
  }

  render () {
    return DOM.div({ className: 'date-time-picker-months' }, [
      DOM.table(
        { key: 'a' },
        DOM.thead(
          {},
          DOM.tr({}, [
            DOM.th(
              {
                key: 'prev',
                className: 'date-time-picker-prev',
                onClick: this.props.subtractTime(1, 'years'),
              },
              DOM.span({}, this.props.prevIcon || '‹')
            ),
            DOM.th(
              {
                key: 'year',
                className: 'date-time-picker-switch',
                onClick: this.props.showView('years'),
                colSpan: 2,
                'data-value': this.props.viewDate.year(),
              },
              this.props.viewDate.year()
            ),
            DOM.th(
              {
                key: 'next',
                className: 'date-time-picker-next',
                onClick: this.props.addTime(1, 'years'),
              },
              DOM.span({}, this.props.nextIcon || '›')
            ),
          ])
        )
      ),
      DOM.table({ key: 'months' }, DOM.tbody({ key: 'b' }, this.renderMonths())),
    ]);
  }

  renderMonths () {
    let date = this.props.selectedDate;
    let month = this.props.viewDate.month();
    let year = this.props.viewDate.year();
    let rows = [];
    let i = 0;
    let months = [];
    let renderer = this.props.renderMonth || this.renderMonth;
    let isValid = this.props.isValidDate || this.alwaysValidDate;
    let classes, props, currentMonth, isDisabled, noOfDaysInMonth, daysInMonth, validDay;
    // Date is irrelevant because we're only interested in month
    let irrelevantDate = 1;

    while (i < 12) {
      classes = 'date-time-picker-month';
      currentMonth = this.props.viewDate
        .clone()
        .set({ year: year, month: i, date: irrelevantDate });

      noOfDaysInMonth = currentMonth.endOf('month').format('D');
      daysInMonth = Array.from({ length: noOfDaysInMonth }, function (e, i) {
        return i + 1;
      });

      validDay = daysInMonth.find(function (d) {
        let day = currentMonth.clone().set('date', d);
        return isValid(day);
      });

      isDisabled = validDay === undefined;

      if (isDisabled) classes += ' date-time-picker-disabled';

      if (date && i === date.month() && year === date.year()) {
        classes += ' date-time-picker-active';
      }

      props = {
        key: i,
        'data-value': i,
        className: classes,
      };

      if (!isDisabled) {
        props.onClick =
          this.props.updateOn === 'months' ? this.updateSelectedMonth : this.props.setDate('month');
      }

      months.push(renderer(props, i, year, date && date.clone()));

      if (months.length === 4) {
        rows.push(DOM.tr({ key: month + '_' + rows.length }, months));
        months = [];
      }

      i++;
    }

    return rows;
  }

  updateSelectedMonth (event) {
    this.props.updateSelectedDate(event);
  }

  renderMonth (props, month) {
    let localMoment = this.props.viewDate;
    let monthStr = localMoment.localeData().months(localMoment.month(month));

    if (!this.props.fullMonth) {
      let strLength = 3;

      // Because some months are up to 5 characters long, we want to
      // use a fixed string length for consistency

      monthStr = monthStr.substring(0, strLength);
    }
    return DOM.td(props, capitalize(monthStr));
  }

  alwaysValidDate () {
    return 1;
  }
}



// WEBPACK FOOTER //
// ./src/containers/date-time-picker/MonthsView.js